import { Component, OnInit, Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';

@Component({
  selector: 'app-confirm-pop-up',
  templateUrl: './confirm-pop-up.component.html',
  styleUrls: ['./confirm-pop-up.component.css']
})
export class ConfirmPopUpComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<ConfirmPopUpComponent>, 
              @Inject(MAT_DIALOG_DATA) public data) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/common/confirm-pop-up/confirm-pop-up.component.ts